<template>
    <Fragment>
        <a class="button" @click="showEmailPicker = true">Overfør</a>
        <form class="dialog" v-if="showEmailPicker" @submit="transfer">
            <p>Dette overfører {{catcher.name}} fra deg til den personen du ønsker.</p>
            <p>Skriv inn e-postadressen til den som skal få kontroll over {{catcher.name}}.</p>
            <label for="email">E-post:</label>
            <input type="email" required v-model="transferEmail" />
            <div class="buttons">
                <button type="submit">Overfør</button>
                <a class="button" v-on:click="showEmailPicker = false">Avbryt</a>
            </div>
        </form>
        <DialogDisplay
            :show="confirmDialog"
            :question="cancelTransferQuestion"
            :ok="ok"
            :cancel="cancel"
        />
    </Fragment>
</template>

<script>
import { Fragment } from 'vue-fragment';
import { Bus, Stops } from '../../common/bus';
import api from '../../common/api';
import url from '../../common/url';
import DialogDisplay from '../common/DialogDisplay.vue';

export default {
    components: { Fragment, DialogDisplay },
    props: { catcher: Object },
    data() {
        return {
            isLoading: false,
            showEmailPicker: false,
            transferEmail: null,
            confirmDialog: false,
            oldTransferEmail: null,
        };
    },
    computed: {
        cancelTransferQuestion() {
            return `Ved neste pålogging av ${this.transferEmail} vil ${this.catcher.name} bli overført til vedkommende.`;
        },
    },
    methods: {
        async transfer(event) {
            event.preventDefault();
            this.oldTransferEmail = this.catcher.transfer ? this.catcher.transfer.toEmail : null;
            this.catcher.transfer = { toEmail: this.transferEmail };
            this.isLoading = true;
            await api.put(url.getCatcher(this.catcher.id), this.catcher);
            this.isLoading = false;
            this.showEmailPicker = false;
            this.confirmDialog = true;
        },
        ok() {
            this.transferEmail = null;
            this.confirmDialog = false;
        },
        async cancel() {
            this.isLoading = true;
            this.catcher.transfer = this.oldTransferEmail ? { toEmail: this.oldTransferEmail } : null;
            await api.put(url.getCatcher(this.catcher.id), this.catcher);
            this.isLoading = false;
            this.transferEmail = null;
            this.confirmDialog = false;
            Bus.$emit(Stops.TOAST, `Overføring av ${this.catcher.name} er kansellert`);
        },
    },
};
</script>

<style lang="scss" scoped>
.dialog {
    position: absolute;
    background: $backgroundColor;
    border: 1px solid $borderColor;
    border-radius: 0.3rem;
    padding: 2rem;
    width: 11rem;
    right: 1rem;
    text-align: left;
}
input {
    margin-bottom: 1rem;
}
label {
    font-size: 1.1rem;
}
p {
    padding-bottom: 1rem;
}
</style>
